<template>
  <div class="centered-container">
    <v-card>
      <v-card-title>{{ $t('account.language.title') }}</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-select v-model="lang" :items="langs"> </v-select>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" @click="submitFormData">
          {{ $t('account.language.submitButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<style lang="scss" scoped>
.centered-container {
  max-width: 600px;
  margin: 0 auto;
}
</style>

<script>
export default {
  components: {},
  data() {
    return {
      lang: this.$i18n.locale,
      langs: [
        { value: 'en', text: this.$t('account.language.english') },
        { value: 'fr', text: this.$t('account.language.french') }
      ]
    }
  },
  computed: {},
  mounted() {
    this.$store.dispatch('app/setSection', 'account')
    // Define window title
    this.$store.dispatch(
      'app/setTitle',
      this.$i18n.t('account.language.pageTitle')
    )
  },
  methods: {
    submitFormData() {
      this.$store
        .dispatch('user/updatePersonalData', { locale: this.lang })
        .then(() => {
          this.$store.dispatch(
            'app/setSnackBarSuccess',
            'account.personalData.accountUpdatedSnack',
            {
              root: true
            }
          )
          this.$router.push({ name: 'account' })
        })
    }
  }
}
</script>
